export { Footer } from './footer';
export { PaymentsFooter } from './compositions/payments-footer';
export { footerCottagesLabels, footerHoseasonsLabels } from './footer.data';
//# sourceMappingURL=index.js.map